var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullyBooked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.599609,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FFCBC8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8608 14.5996V5.87234H12.4517V7.19762H8.44176V9.56694H12.0682V10.8922H8.44176V14.5996H6.8608Z",
    fill: "#D8352A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullyBooked);
export default __webpack_public_path__ + "static/media/fully-booked.70d43defaf3ff56cf662ba2598380227.svg";
export { ForwardRef as ReactComponent };